<template>
    
    <div class="animated fadeIn">
      <b-card no-body>
        <sale-by-range
            :systemid="systemid" />
      </b-card>
    </div>
</template>
<script>
    
  import Vue from 'vue'
  import SaleByRange from './components/SaleByRange'
export default {
    name: 'BookCentreSaleByRange',
    components: {SaleByRange},
    data: function() {
      return {
        systemid: '2',
      }
    },
    methods: {},
    created: {}
}
</script>

